module.exports = __webpack_public_path__ + "img/affilate_form_banner.adc27d37.png";